<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-top-transition"
    max-width="600"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="botao_1" class="rounded-lg" v-bind="attrs" v-on="on" dark
        >NOVO LEMBRETE</v-btn
      >
    </template>

    <v-card class="rounded-lg">
      <v-toolbar dark class="rounded-lg" color="primary">
        Novo Lembrete
      </v-toolbar>

      <br />

      <v-card-text>
        <v-form ref="form">
          <v-text-field
            v-model="form.titulo"
            label="Titulo"
            :rules="[rules.obrigatorio]"
            :counter="100"
            :maxlength="100"
            clear-icon="mdi-close-circle"
            clearable
          ></v-text-field>

          <v-text-field
            v-model="form.tipo"
            label="Tipo"
            :rules="[rules.obrigatorio]"
            :counter="50"
            :maxlength="50"
            clear-icon="mdi-close-circle"
            clearable
          ></v-text-field>


          <v-textarea
            v-model="form.descricao"
            label="Descrição"
            :rules="[rules.obrigatorio]"
            :counter="100"
            :maxlength="100"
            rows="3"
            clear-icon="mdi-close-circle"
            clearable
          ></v-textarea>
        </v-form>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn text @click="dialog = false"> Cancelar </v-btn>
        <v-btn text @click="salvar(form)"> Salvar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/services/api";
import verifica_token_storage from "@/utils/verifica_token_storage";
import { mapMutations } from "vuex";

export default {
  name: "NovoLembrete",

  data: () => ({
    dialog: false,
    formTitle: "Novo Lembrete",
    form: {},
    rules: {
      obrigatorio: (v) => !!v || "Este campo é obrigatório",
    },
  }),

  methods: {
    ...mapMutations(["CarregandoMutation"]),

    salvar(lembrete) {
      if (this.$refs.form.validate()) {
        this.CarregandoMutation();
        const headers = verifica_token_storage();

        api
          .post("lembretes/", lembrete, { headers })
          .then((response) => {
            this.$emit("form-submit", response.data.data[0]);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            // Resetar
            this.dialog = false;
            this.form = {};
            this.CarregandoMutation();
          });
      }
    },
  },
};
</script>
